<script setup lang="ts">
import { NxtSkeleton } from '@future-harry/nxt-styles';
</script>

<template>
   <div class="skeleton-layout">
      <Teleport to=".page-header__bottom">&nbsp;</Teleport>
      <div class="skeleton-left">
         <NxtSkeleton min-height="6rem" max-height="6rem" />
         <NxtSkeleton min-height="6rem" max-height="6rem" />
      </div>
      <div class="skeleton-right">
         <NxtSkeleton min-height="5rem" max-height="5rem" />
         <NxtSkeleton min-height="20rem" max-height="20rem" />
         <NxtSkeleton min-height="10rem" max-height="10rem" />
         <NxtSkeleton min-height="2rem" max-height="2rem" />
      </div>
   </div>
</template>

<style lang="scss" scoped>
.skeleton-layout {
   display: grid;
   gap: var(--nxt-gutter-large);
   grid-template-columns: 20% 80%;
   height: 100%;

   :deep(.shine) {
      background-size: 1000px 100%;
   }

   .skeleton-left {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: var(--nxt-gutter);
      gap: var(--nxt-gutter);
   }

   .skeleton-right {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: var(--nxt-gutter);
      gap: var(--nxt-gutter);
      background-color: white;
   }
}
</style>
